import { gql } from "@apollo/client";

export const getSiteGroupLocationBySiteGroupIdQuery = gql`
query($siteGroupId: String!){
  getSiteGroupLocationBySiteGroupId(siteGroupId: $siteGroupId) {
    message
    response
  }
}
`;


export const deleteSiteGroupLocationByIdQuery = gql`
query($siteGroupLocationId: String!){
  deleteSiteGroupLocationById(siteGroupLocationId: $siteGroupLocationId) {
    message
    response
  }
}
`;